import * as React from 'react';

const FormModalContext = React.createContext(0);

export default FormModalContext;
